<template>
  <div class="flex flex-col w-full">
    <NText variant="caption1" weight="bold" class="block mb-8">
      {{
        t('modules.cash.register_deposit_receipt.cancel_confirmation_message')
      }}
    </NText>

    <div class="flex w-full justify-center">
      <NButton
        variant="flat"
        color="gray"
        class="ml-2 flex-1"
        @click="emit('close')"
      >
        {{ t('common.cancel') }}
      </NButton>

      <NButton
        variant="fill"
        color="red"
        class="flex-1"
        :disabled="isDeletingDepositReceiptRequest"
        :loading="isDeletingDepositReceiptRequest"
        @click="emit('delete', props.requestId)"
      >
        {{ t('common.cancelRequest') }}
      </NButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

type DeleteDepositReceiptDialogEmitType = {
  (e: 'close'): void;
  (e: 'delete', requestId: number): void;
};

type DeleteDepositReceiptDialogPropsType = {
  requestId: number;
  isDeletingDepositReceiptRequest: boolean;
};

const emit = defineEmits<DeleteDepositReceiptDialogEmitType>();

const props = defineProps<DeleteDepositReceiptDialogPropsType>();

const { t } = useI18n();
</script>
